/**
 * Forecast Runs API Service
 * 
 * Handles all API calls related to forecast runs
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  FORECAST_RUNS: '/forecasting/runs',
  FORECAST_RUN_BY_ID: (id) => `/forecasting/runs/${id}`,
  FORECAST_RUN_STATUS: (id) => `/forecasting/runs/${id}/status`,
  FORECAST_DATA: (id) => `/forecasting/data/${id}`,
  FORECAST_COMPARISON: '/forecasting/comparison',
  FORECAST_BY_RUN_ID: (id) => `/forecasting/runs/${id}/forecast`
};

/**
 * Forecast Runs API functions
 */
export const forecastRunsService = {
  // Get all forecast runs
  getForecastRuns: () => api.get(ENDPOINTS.FORECAST_RUNS),
  
  // Get forecast run by ID
  getForecastRunById: (id) => api.get(ENDPOINTS.FORECAST_RUN_BY_ID(id)),
  
  // Update forecast run status
  updateForecastRunStatus: (id, status) => api.put(
    ENDPOINTS.FORECAST_RUN_STATUS(id), 
    { status }
  ),
  
  // Get forecast data for a specific run
  getForecastData: (id, params) => api.get(
    ENDPOINTS.FORECAST_DATA(id), 
    { params }
  ),
  
  // Compare multiple forecast runs
  compareForecastRuns: (runIds, params) => api.post(
    ENDPOINTS.FORECAST_COMPARISON,
    { run_ids: runIds, ...params }
  ),
  
  // Get forecast by run ID (for ForecastChart component)
  getForecastByRunId: (id) => api.get(ENDPOINTS.FORECAST_BY_RUN_ID(id))
}; 